import * as React from "react";
import "./LogoIcon.scss";

function SvgLogoIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="LogoIcon"
    >
      <path
        d="M0 0H49V24.4088H45.9375V3.0511H3.0625V45.7664H24.5V48.8175H0V0Z"
        fill="white"
      />
      <path
        d="M17.6353 32.9844H26.9344V38.4438H10.5364V9.40947H17.6353V32.9844Z"
        fill="white"
      />
      <path
        d="M41.3435 49C40.0003 49 38.7966 48.7828 37.7325 48.3483C36.6685 47.9138 35.8137 47.2708 35.1683 46.4192C34.5403 45.5676 34.2089 44.5423 34.174 43.3431H38.9362C39.006 44.0209 39.2415 44.5423 39.6427 44.9072C40.0439 45.2548 40.5672 45.4286 41.2126 45.4286C41.8755 45.4286 42.3988 45.2809 42.7826 44.9854C43.1664 44.6726 43.3582 44.2468 43.3582 43.7081C43.3582 43.2562 43.2012 42.8826 42.8873 42.5871C42.5907 42.2917 42.2157 42.0484 41.7621 41.8572C41.326 41.666 40.698 41.4488 39.8782 41.2055C38.692 40.8405 37.7238 40.4756 36.9737 40.1106C36.2236 39.7457 35.5782 39.2069 35.0375 38.4944C34.4967 37.7818 34.2263 36.8521 34.2263 35.705C34.2263 34.0019 34.8456 32.6724 36.0841 31.7165C37.3226 30.7433 38.9362 30.2567 40.9248 30.2567C42.9483 30.2567 44.5793 30.7433 45.8178 31.7165C47.0564 32.6724 47.7192 34.0106 47.8065 35.7311H42.9658C42.9309 35.1402 42.7128 34.6797 42.3116 34.3495C41.9104 34.0019 41.3958 33.8281 40.7678 33.8281C40.227 33.8281 39.7909 33.9758 39.4595 34.2713C39.1281 34.5493 38.9624 34.9577 38.9624 35.4965C38.9624 36.0874 39.2415 36.5479 39.7997 36.8781C40.3579 37.2083 41.2301 37.5646 42.4163 37.9469C43.6025 38.3466 44.5619 38.729 45.2945 39.0939C46.0446 39.4589 46.69 39.989 47.2308 40.6841C47.7716 41.3793 48.042 42.2743 48.042 43.3692C48.042 44.4119 47.7716 45.3591 47.2308 46.2107C46.7075 47.0622 45.94 47.74 44.9282 48.244C43.9164 48.748 42.7215 49 41.3435 49Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgLogoIcon;
